import React, { useState, useEffect, useContext } from "react";
import { 
  Grid, Card, TextField, Checkbox, FormControlLabel, 
  Select, MenuItem, InputLabel, FormControl, IconButton, Divider 
} from "@mui/material";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import DownloadIcon from '@mui/icons-material/Download';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ImageIcon from '@mui/icons-material/Image';

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Aapka data API se aayega, ye UI testing ke liye dummy structure hai
const dummyMediaData = [
  { id: "TG07V1212", title: "Distraction", date: "20-06-2026 07:20 AM", status: "Unreviewed", size: "0.38 MB", format: "MP4" },
  { id: "TG07V1213", title: "Driver On Call", date: "20-06-2026 07:30 AM", status: "Unreviewed", size: "0.35 MB", format: "MP4" },
  // ... aur records
];

function Media_GalleryLogs() {
  const [mediaList, setMediaList] = useState(dummyMediaData);
  const [selectAll, setSelectAll] = useState(false);

  // Filter states
  const [filters, setFilters] = useState({
    company: 'All',
    branch: 'All',
    type: 'Evidence',
    event: 'All',
    status: 'All'
  });

  const handleApply = () => {
    // Yahan apni API call lagayein `notificationlogsendpoint` par filters bhej kar
    console.log("Applying filters:", filters);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3}>
        <Grid container spacing={3}>
          
          {/* ==========================================
              LEFT SIDEBAR: FILTER PANEL (Image 1 UI)
          ========================================== */}
          <Grid item xs={12} md={3}>
            <Card sx={{ height: "100%", p: 2 }}>
              <MDTypography variant="h6" fontWeight="medium" mb={2}>
                Filters
              </MDTypography>
              
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Company</InputLabel>
                    <Select value={filters.company} label="Company">
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value="CompA">Company A</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Branch</InputLabel>
                    <Select value={filters.branch} label="Branch">
                      <MenuItem value="All">All</MenuItem>
                      <MenuItem value="BranchA">Branch A</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Type</InputLabel>
                    <Select value={filters.type} label="Type">
                      <MenuItem value="Evidence">Evidence</MenuItem>
                      <MenuItem value="General">General</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Date Selection Box (Add DatePicker here) */}
                <Grid item xs={12}>
                  <TextField type="date" fullWidth size="small" label="Date Selection" InputLabelProps={{ shrink: true }} />
                </Grid>

                {/* Object Selection / Vehicle Tree View */}
                <Grid item xs={12}>
                  <TextField fullWidth size="small" placeholder="Search Object..." />
                  <MDBox mt={1} p={1} sx={{ border: '1px solid #ddd', borderRadius: 1, maxHeight: 200, overflowY: 'auto' }}>
                    <FormControlLabel control={<Checkbox defaultChecked />} label="Trackula [5]" />
                    <MDBox ml={3}>
                      <FormControlLabel control={<Checkbox defaultChecked />} label={<><MDTypography variant="button">TG07V1212</MDTypography><br/><MDTypography variant="caption" color="text">505073157103</MDTypography></>} />
                      <FormControlLabel control={<Checkbox />} label={<><MDTypography variant="button">TS07UM8484</MDTypography><br/><MDTypography variant="caption" color="text">505073606810</MDTypography></>} />
                    </MDBox>
                  </MDBox>
                </Grid>
              </Grid>

              {/* Action Buttons */}
              <MDBox mt={3} display="flex" justifyContent="space-between">
                <MDButton variant="gradient" color="info" size="small" fullWidth sx={{ mr: 1 }}>Update</MDButton>
                <MDButton variant="gradient" color="error" size="small" fullWidth sx={{ mr: 1 }}>Delete</MDButton>
                <MDButton variant="contained" color="primary" size="small" fullWidth onClick={handleApply}>Apply</MDButton>
              </MDBox>
            </Card>
          </Grid>

          {/* ==========================================
              RIGHT SIDEBAR: MEDIA GALLERY (Image 2 UI)
          ========================================== */}
          <Grid item xs={12} md={9}>
            <Card sx={{ height: "100%", p: 2 }}>
              {/* Top Bar */}
              <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2} p={1} sx={{ backgroundColor: "#FB8C00", color: "white", borderRadius: 1 }}>
                <MDTypography variant="h6" color="white">Media Gallery</MDTypography>
                {/* Add Search/Filter icons here */}
              </MDBox>

              <MDBox mb={2}>
                 <FormControlLabel 
                    control={<Checkbox checked={selectAll} onChange={(e) => setSelectAll(e.target.checked)} />} 
                    label="Select All" 
                 />
              </MDBox>

              {/* Gallery Grid */}
              <Grid container spacing={2}>
                {mediaList.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Card sx={{ border: '1px solid #e0e0e0', position: 'relative' }}>
                      
                      {/* Thumbnail Container */}
                      <MDBox position="relative" height={140} sx={{ backgroundColor: '#000', overflow: 'hidden' }}>
                        {/* Checkbox */}
                        <Checkbox sx={{ position: 'absolute', top: 5, left: 5, color: 'white', zIndex: 10 }} />
                        
                        {/* Unreviewed Badge */}
                        {item.status === 'Unreviewed' && (
                           <MDBox sx={{ position: 'absolute', top: 10, right: 10, backgroundColor: '#ffcccc', color: 'red', px: 1, py: 0.5, borderRadius: 1, fontSize: '0.7rem', fontWeight: 'bold' }}>
                             Unreviewed
                           </MDBox>
                        )}
                        
                        {/* Play Button Overlay */}
                        <MDBox sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }}>
                          <PlayCircleOutlineIcon sx={{ fontSize: 40, color: 'white', cursor: 'pointer' }} />
                        </MDBox>

                        {/* Bottom Tags (Size & Format) */}
                        <MDBox sx={{ position: 'absolute', bottom: 5, left: 5, backgroundColor: 'rgba(0,0,0,0.6)', color: 'white', px: 1, fontSize: '0.7rem', borderRadius: 1 }}>
                          {item.size}
                        </MDBox>
                        <MDBox sx={{ position: 'absolute', bottom: 5, right: 5, backgroundColor: 'rgba(0,0,0,0.6)', color: 'white', px: 1, fontSize: '0.7rem', borderRadius: 1 }}>
                          {item.format}
                        </MDBox>
                      </MDBox>

                      {/* Card Content Details */}
                      <MDBox p={1.5}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography variant="subtitle2" fontWeight="bold">{item.title}</MDTypography>
                          <MDBox>
                            <IconButton size="small"><LocationOnIcon fontSize="small" color="info" /></IconButton>
                            <IconButton size="small"><DownloadIcon fontSize="small" color="info" /></IconButton>
                            <IconButton size="small"><ImageIcon fontSize="small" color="info" /></IconButton>
                          </MDBox>
                        </MDBox>
                        
                        <MDTypography variant="caption" color="text" display="block">{item.id}</MDTypography>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={1}>
                          <MDTypography variant="caption" color="text">{item.date}</MDTypography>
                          <MDButton variant="gradient" color="dark" size="small" sx={{ px: 2, py: 0.5, minHeight: 'auto' }}>
                            Review
                          </MDButton>
                        </MDBox>
                      </MDBox>

                    </Card>
                  </Grid>
                ))}
              </Grid>
              
            </Card>
          </Grid>

        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Media_GalleryLogs;